import script from "./ReceiveNFT.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReceiveNFT.vue?vue&type=script&setup=true&lang=ts"

import "./ReceiveNFT.vue?vue&type=style&index=0&id=36d9fb5c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d9fb5c"]])

export default __exports__